export default __webpack_public_path__ + "static/media/instagram.31699492.png";